/* BACDOG product interactions. */
(function () {
  function parseMoneyToNumber(value) {
    if (!value) return 0;

    const raw = String(value).replace(/[^\d,.\-]/g, '');
    const lastComma = raw.lastIndexOf(',');
    const lastDot = raw.lastIndexOf('.');

    // Decimal comma (1.234,56) vs decimal dot (1,234.56)
    const normalized =
      lastComma > lastDot
        ? raw.replace(/\./g, '').replace(',', '.')
        : raw.replace(/,/g, '');

    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function init(info) {
    if (!info) return;

    const configEl = info.querySelector('[data-bacdog-config]');
    if (!configEl) return;

    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      console.error('BACDOG invalid variant data', error);
      return;
    }

    const { variants, sectionId, weightIndex, initialId } = config;

    // Tear down any previous initialisation of this element
    if (info.bacdogPurchaseCleanup) info.bacdogPurchaseCleanup();

    const controller = new AbortController();
    let unsubscribe;
    let observer;
    let active = true;

    info.bacdogPurchaseCleanup = function () {
      active = false;
      controller.abort();
      if (unsubscribe) unsubscribe();
      if (observer) observer.disconnect();
    };

    function findById(id) {
      return variants.find(v => String(v.id) === String(id));
    }

    let selected = findById(initialId) || null;

    /* ---------- Best-value variant ---------- */

    const availableVariants = variants.filter(
      v =>
        v.available === true &&
        Number(v.weightGrams) > 0 &&
        parseMoneyToNumber(v.unitPrice) > 0
    );

    const bestUnitVariant = availableVariants.reduce((best, current) => {
      if (!best) return current;

      const currentPrice = parseMoneyToNumber(current.unitPrice);
      const bestPrice = parseMoneyToNumber(best.unitPrice);

      if (currentPrice < bestPrice) return current;

      // Tie on unit price: prefer the larger format
      if (
        currentPrice === bestPrice &&
        Number(current.weightGrams) > Number(best.weightGrams)
      ) {
        return current;
      }

      return best;
    }, null);

    function isBestVariant(variant) {
      return !!bestUnitVariant && String(bestUnitVariant.id) === String(variant.id);
    }

    /* ---------- Lookups ---------- */

    function getWeightVariantByLabel(labelValue) {
      const target = String(labelValue).trim().toLowerCase();
      return variants.find(
        v => String(v.options[weightIndex]).trim().toLowerCase() === target
      );
    }

    function pickerVariant() {
      const picker = info.querySelector(
        '.bacdog-variant-before-price variant-radios, .bacdog-variant-before-price variant-selects'
      );

      if (!picker) return selected;

      const groups = Array.from(picker.querySelectorAll('[data-option-index]'));
      if (!groups.length) return null;

      const choices = groups.map(group => {
        const checked = group.querySelector('input:checked');
        if (checked) return checked.value;

        const select = group.querySelector('select');
        return select ? select.value : null;
      });

      return variants.find(
        v =>
          v.options.length === choices.length &&
          v.options.every((value, i) => value === choices[i])
      );
    }

    /* ---------- Rendering ---------- */

    function decorateWeightCards() {
      const pickerWrap = info.querySelector('.bacdog-variant-before-price');
      if (!pickerWrap) return;

      const field = pickerWrap.querySelector(
        'fieldset[data-option-index="' + weightIndex + '"]'
      );
      if (!field) return;

      field.querySelectorAll('label').forEach(label => {
        let radio = label.previousElementSibling;
        if (!radio || radio.tagName !== 'INPUT') {
          const id = label.getAttribute('for');
          if (id) radio = field.querySelector('#' + CSS.escape(id));
        }

        const value = radio ? radio.value : label.textContent.trim();
        const variant = getWeightVariantByLabel(value);
        if (!variant) return;

        const soldOut = variant.available === false;
        label.classList.toggle('bacdog-out-of-stock', soldOut);

        const totalText = soldOut ? 'Agotado' : variant.totalPrice;
        const unitText = soldOut ? '' : `(${variant.unitPrice}${variant.unitLabel})`;

        label.innerHTML = `
          <span class="bacdog-card">
            <span class="bacdog-card__weight">${variant.weightLabel}</span>
            <span class="bacdog-card__price">${totalText}</span>
            ${unitText ? `<span class="bacdog-card__unit">${unitText}</span>` : ''}
            <span class="bacdog-card__badge">${isBestVariant(variant) ? 'AHORRO' : ''}</span>
          </span>
        `;
      });
    }

    function paint(variant) {
      const card = info.querySelector('#bacdog-unit-price-' + sectionId);
      if (!card) return;

      selected = variant;

      const valid = !!variant && Number(variant.weightGrams) > 0;
      card.hidden = !valid;
      info.classList.toggle('bacdog-has-unit-price', valid);

      const label = info.querySelector('.bacdog-bag-total__label');
      if (label) {
        if (variant && variant.weightLabel !== 'Default Title') {
          label.textContent =
            variant.unitLabel === '/ 100 g'
              ? 'Precio total del envase de ' + variant.weightLabel
              : 'Precio total del saco de ' + variant.weightLabel;
        } else {
          label.textContent = 'Precio total';
        }
      }

      if (!valid) return;

      const title = card.querySelector('.bacdog-unit-price__title');
      const number = card.querySelector('.bacdog-unit-price__number');
      const unit = card.querySelector('.bacdog-unit-price__unit');
      const badge = card.querySelector('.bacdog-unit-price__badge');

      if (title) title.textContent = variant.unitTitle;
      if (number) number.textContent = variant.unitPrice;
      if (unit) unit.textContent = variant.unitLabel;
      if (badge) badge.style.display = isBestVariant(variant) ? 'inline-flex' : 'none';

      decorateWeightCards();
    }

    /* ---------- Layout ---------- */

    function build() {
      if (!active || !info.isConnected) return;

      const nativePrice = info.querySelector('#price-' + sectionId);
      const card = info.querySelector('#bacdog-unit-price-' + sectionId);
      const buy = info.querySelector('.buy-buttons-block');

      if (!nativePrice || !card || !buy) return;

      info.classList.add('bacdog-purchase-layout');

      // Wrap the native price in a "bag total" container, with the unit-price card above it
      if (!nativePrice.closest('.bacdog-bag-total')) {
        const customBlock = card.closest('.block');

        const total = document.createElement('div');
        total.className = 'bacdog-bag-total';

        const label = document.createElement('span');
        label.className = 'bacdog-bag-total__label';

        nativePrice.before(total);
        total.append(label, nativePrice);
        total.before(card);

        const tax = total.parentElement.querySelector('.product-tax');
        if (tax) tax.classList.add('bacdog-purchase-tax');

        if (customBlock && !customBlock.contains(nativePrice)) {
          customBlock.style.display = 'none';
        }
      }

      const priceBlock = nativePrice.closest('.block');
      if (priceBlock) priceBlock.classList.add('bacdog-price-block');

      const buyBlock = buy.closest('.block');
      if (buyBlock) buyBlock.classList.add('bacdog-buy-block');

     const delivery = info.querySelector('delivery-estimator');
      const deliveryBlock = delivery ? delivery.closest('.block') : null;
      if (deliveryBlock) {
        deliveryBlock.classList.add('bacdog-delivery-block');

        // Move delivery block to sit DIRECTLY BELOW the buy-buttons-block
        if (buyBlock && deliveryBlock.previousElementSibling !== buyBlock) {
          buyBlock.parentNode.insertBefore(deliveryBlock, buyBlock.nextSibling);
        }

        // Inject "IMPUESTOS INCLUIDOS - FABRICADO EN ESPAÑA" with checkmark above delivery text
        const deliveryContainer = deliveryBlock.querySelector('.product-delivery-date') || deliveryBlock.querySelector('delivery-estimator');
        if (deliveryContainer && !deliveryBlock.querySelector('.bacdog-tax-line')) {
          const taxDiv = document.createElement('div');
          taxDiv.className = 'bacdog-tax-line';
          taxDiv.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            <span>IMPUESTOS INCLUIDOS - FABRICADO EN ESPAÑA</span>
          `;
          deliveryContainer.prepend(taxDiv);
        }
      }

      const pickerWrap = info.querySelector('.bacdog-variant-before-price');
      if (pickerWrap) {
        if (!pickerWrap.querySelector('.bacdog-format-heading')) {
          const heading = document.createElement('p');
          heading.className = 'bacdog-format-heading';
          heading.textContent = 'Elige tu formato';
          pickerWrap.prepend(heading);
        }

        const field = pickerWrap.querySelector(
          'fieldset[data-option-index="' + weightIndex + '"]'
        );
        if (field && !field.classList.contains('bacdog-weight-field')) {
          field.classList.add('bacdog-weight-field');

          const caption = document.createElement('span');
          caption.className = 'bacdog-weight-caption';
          caption.textContent = 'Peso';
          caption.setAttribute('aria-hidden', 'true');

          const legend = field.querySelector('legend');
          if (legend) legend.after(caption);
          else field.prepend(caption);
        }
      }

      buy.classList.toggle('bacdog-no-quantity', !buy.querySelector('quantity-input'));

      const duplicateShipping = buy.querySelector('.bacdog-free-shipping');
      if (duplicateShipping) duplicateShipping.remove();

      decorateWeightCards();
      paint(pickerVariant() || selected);
    }

    /* ---------- Events ---------- */

    function start() {
      if (!active) return;

      build();

      info.addEventListener(
        'change',
        event => {
          if (event.target.closest('variant-radios, variant-selects')) {
            paint(pickerVariant());
          } else if (event.target.matches('.product-variant-id')) {
            paint(findById(event.target.value));
          }
        },
        { signal: controller.signal }
      );

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          const expected = info.dataset.originalSection || sectionId;
          if (!active || String(event.data.sectionId) !== String(expected)) return;

          paint(pickerVariant());
        });
      }

      // Rebuild when the theme re-renders the variant picker
      observer = new MutationObserver(records => {
        const pickerAdded = records.some(record =>
          Array.from(record.addedNodes).some(
            node =>
              node.nodeType === 1 &&
              (node.matches('variant-radios, variant-selects, fieldset') ||
                node.querySelector('variant-radios, variant-selects, fieldset'))
          )
        );

        if (pickerAdded) build();
      });

      observer.observe(info, { childList: true, subtree: true });
    }

    start();
  }

  function initAll(root = document) {
    if (root.matches && root.matches('product-info')) {
      init(root);
    }
    root.querySelectorAll('product-info').forEach(el => init(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();